export default __webpack_public_path__ + "static/media/rich_content.020ef624.svg";